(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .factory('Picture', Picture);

    Picture.$inject = ['$http'];

    function Picture($http) {

        var service = {
            getProfilePicture : getProfilePicture, getProfilePictureByEmail : getProfilePictureByEmail
        };
        return service;

        function getProfilePicture(id) {
            return $http.get('api/profiles/'+id+'/picture',{ignoreLoadingBar: true}).then(function (res) {
                if (res && res.data) {
                    return res.data;
                }
            });
        }

        function getProfilePictureByEmail(email) {
            return $http.get('api/profiles/email/'+email+'/picture',{ignoreLoadingBar: true}).then(function (res) {
                if (res && res.data) {
                    return res.data;
                }
            });
        }
    }
})();